const initialState: { hide?: boolean } = {
  hide: undefined,
}

export const LoadingActionNames = Object.freeze({
  SHOW: 'LOADING_SHOW',
  HIDE: 'LOADING_HIDE',
  CLEAR: 'LOADING_CLEAR',
})

export const LoadingActions = {
  show: () => ({ type: LoadingActionNames.SHOW }),
  hide: () => ({ type: LoadingActionNames.HIDE }),
  clear: () => ({ type: LoadingActionNames.CLEAR }),
}

export const LoadingReducer = (state = initialState, action: any): typeof initialState => {
  switch (action.type) {
    case LoadingActionNames.SHOW:
      return { ...state, hide: false }
    case LoadingActionNames.HIDE:
      return { ...state, hide: true }
    case LoadingActionNames.CLEAR:
      return { ...state, hide: undefined }
    default:
      return state
  }
}